import { render, staticRenderFns } from "./UrlTabs.vue?vue&type=template&id=2d90f062&"
import script from "./UrlTabs.vue?vue&type=script&lang=js&"
export * from "./UrlTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports